import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismRadioGroup } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import HotelBudgetForecastDateRange from 'lumen/components/hotel/budget-forecast/date-range';
import type { ExportOptions } from 'lumen/components/hotel/budget-forecast/export-modal';
import type { DateGranularity } from 'lumen/utils/constants/budget-forecast-constants';

interface HotelBudgetForecastExportModalSelectDateRangeSignature {
  Args: {
    exportOptions: ExportOptions;
    exportType: 'custom' | 'finance-system';
    onChange: (options: Partial<ExportOptions>) => void;
  };
}

export default class HotelBudgetForecastExportModalSelectDateRange extends Component<HotelBudgetForecastExportModalSelectDateRangeSignature> {
  @action
  onGranularityChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value as DateGranularity;
    this.args.onChange({ granularity: value });
  }

  <template>
    <p
      class="text-300--regular"
      data-test-id="export-modal-date-range-description"
    >
      {{t "budget_forecast.export.select_date_range"}}:
    </p>

    {{#if (eq @exportType "custom")}}
      <div
        class="flex flex-col gap-200"
        data-test-id="date-granularity-selector"
      >
        <label class="heading-4">
          {{t "general.granularity"}}
        </label>

        <PrismRadioGroup
          @isHorizontal={{true}}
          @name="granularity"
          @onChange={{this.onGranularityChange}}
          @value={{@exportOptions.granularity}}
          as |RadioGroup|
        >
          <RadioGroup.input @value="day">
            {{t "general.day"}}
          </RadioGroup.input>
          <RadioGroup.input @value="month">
            {{t "general.month"}}
          </RadioGroup.input>
        </PrismRadioGroup>
      </div>
    {{/if}}

    <HotelBudgetForecastDateRange
      @endDate={{@exportOptions.endDate}}
      @granularity={{@exportOptions.granularity}}
      @onChange={{@onChange}}
      @startDate={{@exportOptions.startDate}}
      class={{if (eq @exportType "custom") "ml-600"}}
    />
  </template>
}
